import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
  color: #0f172a;
  background: #f5f7fa;
}

* {
  box-sizing: border-box;
}

button,
input,
select {
  font: inherit;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.lsit-shell {
  min-height: 100vh;
  background: #f5f7fa;
}

.lsit-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 30;
  display: flex;
  width: 248px;
  flex-direction: column;
  padding: 24px 18px;
  color: #e2e8f0;
  background: #0b1f3a;
  border-right: 1px solid #173353;
}

.brand-block {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0 8px 25px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
}

.brand-mark {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border-radius: 10px;
  color: #fff;
  background: #0f8b82;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 6px 18px rgba(15, 139, 130, 0.22);
}

.brand-title {
  color: #f8fafc;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.brand-subtitle {
  margin-top: 2px;
  color: #7792b2;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.nav-list {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 5px;
  padding-top: 22px;
}

.nav-item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
  border: 1px solid transparent;
  border-radius: 9px;
  padding: 9px 10px;
  color: #9fb1c8;
  background: transparent;
  font-size: 12px;
  font-weight: 550;
  text-align: left;
  transition: 160ms ease;
}

.nav-item:hover {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.05);
}

.nav-item.active {
  color: #fff;
  background: #143455;
  border-color: #205070;
  box-shadow: inset 3px 0 #2dd4bf;
}

.nav-code {
  display: grid;
  min-width: 36px;
  height: 24px;
  place-items: center;
  border-radius: 6px;
  color: #6f8baa;
  background: rgba(255, 255, 255, 0.05);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.nav-item.active .nav-code {
  color: #99f6e4;
  background: rgba(45, 212, 191, 0.12);
}

.runtime-card {
  margin-top: 18px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 10px;
  padding: 13px;
  background: rgba(3, 15, 31, 0.3);
}

.sidebar-footer {
  margin-top: 12px;
  color: #58718f;
  font-size: 9px;
  text-align: center;
}

.lsit-main {
  min-height: 100vh;
  margin-left: 248px;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 30px;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid #e2e8f0;
  backdrop-filter: blur(12px);
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-heading {
  margin-top: 2px;
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.eyebrow,
.section-kicker {
  color: #0f766e;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.engine-badge,
.meta-chip,
.step-badge,
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #d8e1ea;
  border-radius: 999px;
  padding: 5px 9px;
  color: #475569;
  background: #f8fafc;
  font-size: 10px;
  font-weight: 650;
  white-space: nowrap;
}

.engine-badge.offline {
  color: #be123c;
  background: #fff1f2;
  border-color: #fecdd3;
}

.status-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  flex: none;
}

.status-dot-online {
  background: #14b8a6;
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.14);
}

.status-dot-error {
  background: #f43f5e;
  box-shadow: 0 0 0 3px rgba(244, 63, 94, 0.12);
}

.mobile-nav {
  display: none;
}

.content-wrap {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
  padding: 26px 30px 48px;
}

.panel,
.image-panel,
.feature-card,
.summary-card {
  border: 1px solid #dde5ed;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.035);
}

.panel {
  padding: 20px;
}

.panel-heading,
.section-header,
.image-panel-head,
.download-strip {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.section-header {
  align-items: center;
  min-height: 58px;
}

.section-title {
  color: #0f172a;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.view-title {
  margin-top: 3px;
  color: #0f172a;
  font-size: 23px;
  font-weight: 750;
  letter-spacing: -0.025em;
}

.view-description {
  margin-top: 5px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.6;
}

.hero-panel {
  display: grid;
  min-height: 310px;
  grid-template-columns: 1fr 310px;
  align-items: center;
  gap: 40px;
  overflow: hidden;
  border: 1px solid #cbd8e5;
  border-radius: 16px;
  padding: 42px 46px;
  color: #dce8f5;
  background-color: #0e2a47;
  background-image: linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 34px 34px;
}

.inline-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(45, 212, 191, 0.28);
  border-radius: 999px;
  padding: 6px 10px;
  color: #99f6e4;
  background: rgba(15, 118, 110, 0.18);
  font-size: 10px;
  font-weight: 650;
}

.hero-title {
  max-width: 850px;
  margin-top: 22px;
  color: #fff;
  font-size: clamp(29px, 3.2vw, 47px);
  font-weight: 720;
  line-height: 1.18;
  letter-spacing: -0.035em;
}

.hero-copy {
  max-width: 760px;
  margin-top: 17px;
  color: #a9bdd1;
  font-size: 13px;
  line-height: 1.8;
}

.hero-facts {
  display: grid;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 13px;
  background: rgba(3, 15, 31, 0.32);
}

.fact-cell {
  display: flex;
  min-height: 78px;
  flex-direction: column;
  justify-content: center;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.16);
}

.fact-cell:last-child {
  border-bottom: 0;
}

.fact-value {
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}

.fact-label {
  margin-top: 3px;
  color: #7892ad;
  font-size: 10px;
}

.button {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 8px 13px;
  font-size: 11px;
  font-weight: 700;
  transition: 150ms ease;
}

.button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.button-primary {
  color: #fff;
  background: #0f766e;
  border-color: #0f766e;
  box-shadow: 0 3px 10px rgba(15, 118, 110, 0.16);
}

.button-primary:hover:not(:disabled) {
  background: #0d665f;
}

.button-secondary {
  color: #334155;
  background: #fff;
  border-color: #cbd5e1;
}

.hero-panel .button-secondary {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(226, 232, 240, 0.25);
}

.button-danger {
  color: #be123c;
  background: #fff1f2;
  border-color: #fecdd3;
}

.button-small {
  min-height: 31px;
  padding: 6px 10px;
  font-size: 10px;
}

.workflow-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-top: 18px;
}

.workflow-item {
  position: relative;
  min-height: 130px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 15px;
  background: #fbfcfd;
}

.workflow-index {
  color: #0f766e;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 10px;
  font-weight: 800;
}

.workflow-item h4 {
  margin-top: 18px;
  color: #1e293b;
  font-size: 12px;
  font-weight: 700;
}

.workflow-item p {
  margin-top: 7px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.55;
}

.example-grid,
.comparison-images {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.example-grid figure,
.comparison-images figure,
.gallery-grid figure {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #f8fafc;
}

.example-grid img,
.comparison-images img {
  display: block;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
}

.example-grid figcaption,
.comparison-images figcaption {
  padding: 8px 10px;
  color: #475569;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  font-size: 9px;
  text-align: center;
}

.feature-card {
  min-height: 130px;
  padding: 20px;
}

.feature-icon {
  display: inline-grid;
  min-width: 40px;
  height: 27px;
  place-items: center;
  border-radius: 7px;
  padding: 0 8px;
  color: #0f766e;
  background: #e6fffb;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 9px;
  font-weight: 800;
}

.feature-card h3 {
  margin-top: 16px;
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
}

.feature-card p {
  margin-top: 6px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.65;
}

.form-section {
  padding: 4px 0 24px;
  border-bottom: 1px solid #e8edf2;
}

.form-section + .form-section {
  padding-top: 24px;
}

.form-section:last-child {
  padding-bottom: 4px;
  border-bottom: 0;
}

.form-section-title {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 17px;
}

.form-section-title h3 {
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
}

.form-section-title p {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 9px;
}

.group-number {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 8px;
  color: #0f766e;
  background: #e9f7f5;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 9px;
  font-weight: 800;
}

.field {
  display: block;
}

.field-label {
  display: flex;
  min-height: 19px;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  color: #334155;
  font-size: 10px;
  font-weight: 700;
}

.help-mark {
  display: inline-grid;
  width: 15px;
  height: 15px;
  place-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 50%;
  color: #64748b;
  background: #fff;
  font-size: 8px;
}

.field-control,
.compact-control {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  color: #0f172a;
  background: #fff;
  outline: none;
  transition: border 150ms ease, box-shadow 150ms ease;
}

.field-control {
  min-height: 37px;
  padding: 8px 10px;
  font-size: 11px;
}

.compact-control {
  min-height: 32px;
  padding: 6px 8px;
  font-size: 10px;
}

.field-control:focus,
.compact-control:focus {
  border-color: #0d9488;
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.11);
}

.input-unit {
  position: relative;
}

.input-unit .field-control {
  padding-right: 55px;
}

.input-unit > span {
  position: absolute;
  top: 50%;
  right: 10px;
  color: #94a3b8;
  font-size: 9px;
  pointer-events: none;
  transform: translateY(-50%);
}

.field-help {
  display: block;
  margin-top: 5px;
  color: #94a3b8;
  font-size: 9px;
}

.field-error {
  display: block;
  margin-top: 5px;
  color: #e11d48;
  font-size: 9px;
  font-weight: 650;
}

.warning-box,
.info-box {
  border-radius: 8px;
  padding: 11px 12px;
  font-size: 10px;
  line-height: 1.55;
}

.warning-box {
  color: #92400e;
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.info-box {
  color: #155e75;
  background: #ecfeff;
  border: 1px solid #a5f3fc;
}

.check-line {
  display: flex;
  align-items: center;
  gap: 9px;
  border-radius: 7px;
  padding: 8px 9px;
  color: #64748b;
  background: #f8fafc;
  font-size: 10px;
}

.check-line > span {
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  border-radius: 50%;
  color: #64748b;
  background: #e2e8f0;
  font-size: 9px;
  font-weight: 800;
}

.check-ok {
  color: #166534;
  background: #f0fdf4;
}

.check-ok > span {
  color: #fff;
  background: #16a34a;
}

.check-error {
  color: #be123c;
  background: #fff1f2;
}

.check-error > span {
  color: #fff;
  background: #e11d48;
}

.summary-list {
  margin-top: 16px;
  border-top: 1px solid #e2e8f0;
}

.summary-list > div {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  padding: 9px 0;
  border-bottom: 1px solid #edf1f5;
  font-size: 9px;
}

.summary-list dt {
  color: #64748b;
}

.summary-list dd {
  color: #1e293b;
  font-weight: 700;
  text-align: right;
}

.sticky-panel {
  position: sticky;
  top: 94px;
}

.result-toolbar {
  display: flex;
  min-height: 50px;
  align-items: center;
  gap: 18px;
  border: 1px solid #dce4eb;
  border-radius: 10px;
  padding: 8px 12px;
  background: #fff;
}

.result-toolbar label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 10px;
  font-weight: 650;
}

.result-toolbar .compact-control {
  width: 105px;
}

.zoom-control {
  display: inline-flex;
  overflow: hidden;
  align-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
}

.zoom-control button,
.zoom-control span {
  display: grid;
  min-width: 31px;
  height: 30px;
  place-items: center;
  color: #334155;
  background: #fff;
  font-size: 11px;
}

.zoom-control span {
  min-width: 52px;
  border-inline: 1px solid #e2e8f0;
  font-size: 9px;
}

.pixel-readout {
  margin-left: auto;
  color: #475569;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 9px;
}

.image-panel {
  overflow: hidden;
}

.image-panel-head {
  align-items: center;
  padding: 15px 17px;
  border-bottom: 1px solid #e2e8f0;
}

.image-panel-head h3 {
  margin-top: 2px;
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
}

.text-button {
  color: #0f766e;
  font-size: 10px;
  font-weight: 700;
}

.image-stage {
  display: grid;
  min-height: 390px;
  place-items: center;
  overflow: auto;
  padding: 22px;
  background-color: #0f172a;
  background-image: linear-gradient(45deg, #16243a 25%, transparent 25%), linear-gradient(-45deg, #16243a 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #16243a 75%), linear-gradient(-45deg, transparent 75%, #16243a 75%);
  background-position: 0 0, 0 9px, 9px -9px, -9px 0;
  background-size: 18px 18px;
}

.image-stage img {
  display: block;
  max-width: min(100%, 560px);
  max-height: 560px;
  border-radius: 3px;
  image-rendering: auto;
  transform-origin: center;
  transition: transform 120ms ease;
}

.image-panel figcaption {
  padding: 10px 16px;
  color: #64748b;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  font-size: 9px;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.metric-card {
  min-height: 100px;
  border: 1px solid #dce4eb;
  border-radius: 11px;
  padding: 15px;
  background: #fff;
}

.metric-card span,
.metric-card small {
  display: block;
  color: #64748b;
  font-size: 9px;
}

.metric-card strong {
  display: block;
  margin: 9px 0 4px;
  color: #0f2f4d;
  font-size: 20px;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.radial-chart {
  display: block;
  width: 100%;
  height: 210px;
  margin-top: 12px;
  overflow: visible;
}

.chart-axis {
  stroke: #cbd5e1;
  stroke-width: 1;
}

.chart-line {
  fill: none;
  stroke: #0f766e;
  stroke-width: 2;
  vector-effect: non-scaling-stroke;
}

.chart-legend {
  display: flex;
  align-items: center;
  color: #64748b;
  font-size: 9px;
}

.legend-line {
  width: 20px;
  height: 2px;
  margin-right: 7px;
  background: #0f766e;
}

.legend-box {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.download-list {
  display: grid;
  gap: 7px;
  margin-top: 15px;
}

.download-list button {
  display: flex;
  min-height: 33px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  padding: 7px 10px;
  color: #475569;
  background: #fff;
  font-size: 10px;
  text-align: left;
}

.download-list button::after {
  content: "↓";
  color: #0f766e;
  font-weight: 800;
}

.download-list button:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.download-list .primary-download {
  color: #fff;
  background: #0f766e;
  border-color: #0f766e;
}

.download-list .primary-download::after {
  color: #fff;
}

.divider {
  height: 1px;
  margin: 24px 0;
  background: #e8edf2;
}

.count-card strong {
  display: block;
  margin-top: 12px;
  color: #0f2f4d;
  font-size: 38px;
  line-height: 1;
  letter-spacing: -0.04em;
}

.count-card > span {
  display: block;
  margin-top: 6px;
  color: #64748b;
  font-size: 11px;
}

.count-ok,
.count-warning {
  margin-top: 15px;
  border-radius: 7px;
  padding: 8px 9px;
  font-size: 9px;
  font-weight: 650;
}

.count-ok {
  color: #166534;
  background: #f0fdf4;
}

.count-warning {
  color: #92400e;
  background: #fffbeb;
}

.progress-track,
.mini-progress {
  overflow: hidden;
  border-radius: 99px;
  background: #e2e8f0;
}

.progress-track {
  height: 7px;
  margin-top: 13px;
}

.progress-track > div,
.mini-progress > div {
  height: 100%;
  background: #0f8b82;
  transition: width 300ms ease;
}

.progress-stats {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  color: #64748b;
  font-size: 8px;
}

.status-success {
  color: #166534;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.status-running {
  color: #0e7490;
  background: #ecfeff;
  border-color: #a5f3fc;
}

.status-warning {
  color: #92400e;
  background: #fffbeb;
  border-color: #fde68a;
}

.status-error {
  color: #be123c;
  background: #fff1f2;
  border-color: #fecdd3;
}

.chip-error {
  color: #be123c;
  background: #fff1f2;
  border-color: #fecdd3;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 9px;
  white-space: nowrap;
}

.data-table th {
  padding: 9px 10px;
  color: #64748b;
  background: #f8fafc;
  border-block: 1px solid #e2e8f0;
  font-weight: 700;
  text-align: left;
}

.data-table td {
  padding: 10px;
  color: #334155;
  border-bottom: 1px solid #edf1f5;
}

.data-table tbody tr:hover {
  background: #fbfcfd;
}

.histogram {
  display: flex;
  min-height: 185px;
  align-items: flex-end;
  gap: 6px;
  margin-top: 20px;
  padding: 15px 8px 0;
  border-bottom: 1px solid #cbd5e1;
}

.histogram-bar-wrap {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.histogram-count {
  margin-bottom: 4px;
  color: #64748b;
  font-size: 7px;
}

.histogram-bar {
  width: 70%;
  min-width: 5px;
  border-radius: 4px 4px 0 0;
  background: #0f8b82;
}

.histogram-bar-wrap small {
  max-width: 38px;
  margin-top: 5px;
  overflow: hidden;
  color: #94a3b8;
  font-size: 6px;
  text-overflow: ellipsis;
}

.correlation-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(74px, 1fr));
  gap: 5px;
  margin-top: 16px;
  overflow-x: auto;
}

.correlation-cell {
  display: flex;
  min-height: 70px;
  flex-direction: column;
  justify-content: center;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 7px;
  padding: 7px;
  color: #0f172a;
}

.correlation-cell span,
.correlation-cell small {
  overflow: hidden;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.correlation-cell strong {
  margin: 5px 0;
  font-size: 13px;
}

.sensitivity-grid {
  --cols: 3;
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(58px, 1fr));
  gap: 5px;
  margin-top: 18px;
  overflow-x: auto;
}

.sensitivity-cell {
  display: grid;
  min-height: 48px;
  place-items: center;
  border-radius: 6px;
  color: #fff;
  background: #0f766e;
  font-size: 8px;
  font-weight: 700;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 17px;
}

.gallery-grid img {
  display: block;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
}

.gallery-grid figcaption {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 8px 9px;
  color: #334155;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  font-size: 8px;
}

.gallery-grid figcaption small {
  color: #64748b;
  font-size: 7px;
}

.filter-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-top: 15px;
  flex-wrap: wrap;
}

.filter-row label {
  display: flex;
  min-width: 115px;
  flex-direction: column;
  gap: 5px;
  color: #64748b;
  font-size: 8px;
}

.pagination-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding-top: 15px;
  color: #64748b;
  font-size: 9px;
}

.pagination-row button {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 5px 9px;
  color: #334155;
  background: #fff;
}

.download-strip {
  align-items: center;
}

.download-strip h3 {
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
}

.download-strip p {
  margin-top: 4px;
  color: #64748b;
  font-size: 9px;
}

.reconstruction-stage {
  position: relative;
  display: grid;
  min-height: 430px;
  place-items: center;
  margin-top: 16px;
  overflow: hidden;
  border-radius: 10px;
  background: #0f172a;
}

.reconstruction-stage img {
  display: block;
  max-width: 100%;
  max-height: 540px;
}

.focus-badge {
  position: absolute;
  right: 12px;
  bottom: 12px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 7px;
  padding: 6px 8px;
  color: #ccfbf1;
  background: rgba(3, 15, 31, 0.78);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 8px;
}

.depth-slider {
  width: 100%;
  margin: 18px 0 7px;
  accent-color: #0f766e;
}

.summary-card {
  padding: 16px;
}

.summary-card span {
  display: block;
  color: #64748b;
  font-size: 9px;
}

.summary-card strong {
  display: block;
  margin-top: 7px;
  color: #0f2f4d;
  font-size: 24px;
}

.history-table {
  min-width: 930px;
}

.mini-progress {
  width: 70px;
  height: 5px;
  margin-bottom: 4px;
}

.table-action {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 5px 8px;
  color: #334155;
  background: #fff;
  font-size: 8px;
  font-weight: 650;
}

.table-action.danger {
  color: #be123c;
  border-color: #fecdd3;
}

.empty-cell {
  padding: 45px !important;
  color: #94a3b8 !important;
  text-align: center;
}

.empty-state {
  display: grid;
  min-height: 240px;
  place-items: center;
  align-content: center;
  padding: 35px;
  color: #64748b;
  text-align: center;
}

.empty-state h3 {
  color: #1e293b;
  font-size: 14px;
  font-weight: 700;
}

.empty-state p {
  margin-top: 7px;
  font-size: 10px;
}

.docs-grid {
  display: grid;
  grid-template-columns: 230px minmax(0, 1fr);
  align-items: start;
  gap: 18px;
}

.docs-toc {
  position: sticky;
  top: 94px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.docs-toc a {
  border-radius: 6px;
  padding: 7px 8px;
  color: #475569;
  font-size: 10px;
}

.docs-toc a:hover {
  color: #0f766e;
  background: #f0fdfa;
}

.docs-content {
  padding: 28px;
}

.docs-content section {
  padding-bottom: 30px;
  border-bottom: 1px solid #e2e8f0;
  scroll-margin-top: 100px;
}

.docs-content section + section {
  padding-top: 30px;
}

.docs-content section:last-child {
  border-bottom: 0;
}

.docs-content h3 {
  margin-top: 5px;
  color: #0f172a;
  font-size: 17px;
  font-weight: 720;
}

.docs-content p,
.docs-content li {
  color: #475569;
  font-size: 11px;
  line-height: 1.8;
}

.docs-content h3 + p,
.docs-content h3 + ol,
.docs-content h3 + ul,
.docs-content h3 + pre {
  margin-top: 13px;
}

.docs-content ol,
.docs-content ul {
  padding-left: 18px;
}

.docs-content ol {
  list-style: decimal;
}

.docs-content ul {
  list-style: disc;
}

.docs-content pre {
  overflow-x: auto;
  border: 1px solid #233d5a;
  border-radius: 9px;
  padding: 15px;
  color: #d9e8f5;
  background: #0b1f3a;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 9px;
  line-height: 1.65;
}

.docs-table {
  display: grid;
  gap: 7px;
  margin-top: 15px;
}

.docs-table > div {
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  padding: 9px 11px;
  font-size: 10px;
}

.docs-table strong {
  color: #1e293b;
}

.docs-table span {
  color: #64748b;
}

.busy-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(2, 13, 28, 0.7);
  backdrop-filter: blur(4px);
}

.busy-card {
  width: min(520px, 100%);
  border: 1px solid #d9e2eb;
  border-radius: 14px;
  padding: 30px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(2, 13, 28, 0.28);
  text-align: center;
}

.busy-spinner {
  width: 38px;
  height: 38px;
  margin: 0 auto 18px;
  border: 3px solid #ccfbf1;
  border-top-color: #0f766e;
  border-radius: 50%;
  animation: spin 800ms linear infinite;
}

.busy-card h2 {
  margin-top: 7px;
  color: #0f172a;
  font-size: 17px;
  font-weight: 750;
}

.busy-card > p:not(.section-kicker) {
  margin-top: 8px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.6;
}

.busy-steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  margin-top: 20px;
}

.busy-steps span {
  border-radius: 6px;
  padding: 7px 4px;
  color: #0f766e;
  background: #f0fdfa;
  font-size: 8px;
  font-weight: 650;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1279px) {
  .workflow-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .metric-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .hero-panel {
    grid-template-columns: 1fr 250px;
    padding: 35px;
  }
}
@media (max-width: 1023px) {
  .lsit-sidebar {
    display: none;
  }
  .lsit-main {
    margin-left: 0;
  }
  .mobile-nav {
    display: flex;
    gap: 6px;
    overflow-x: auto;
    padding: 10px 18px;
    background: #0b1f3a;
  }
  .mobile-nav button {
    flex: none;
    border: 1px solid #244360;
    border-radius: 7px;
    padding: 7px 10px;
    color: #9fb1c8;
    background: transparent;
    font-size: 9px;
  }
  .mobile-nav button.active {
    color: #fff;
    background: #0f766e;
    border-color: #0f766e;
  }
  .hero-panel {
    grid-template-columns: 1fr;
  }
  .hero-facts {
    grid-template-columns: repeat(3, 1fr);
  }
  .fact-cell {
    min-height: 65px;
    border-right: 1px solid rgba(148, 163, 184, 0.16);
    border-bottom: 0;
  }
  .fact-cell:last-child {
    border-right: 0;
  }
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .docs-grid {
    grid-template-columns: 1fr;
  }
  .docs-toc {
    position: static;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 767px) {
  .topbar {
    padding: 12px 16px;
  }
  .topbar-actions .engine-badge {
    display: none;
  }
  .content-wrap {
    padding: 18px 14px 38px;
  }
  .section-header,
  .panel-heading,
  .download-strip,
  .result-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .hero-panel {
    min-height: 0;
    padding: 27px 22px;
  }
  .hero-title {
    font-size: 29px;
  }
  .hero-facts {
    grid-template-columns: 1fr;
  }
  .fact-cell {
    border-right: 0;
    border-bottom: 1px solid rgba(148, 163, 184, 0.16);
  }
  .workflow-grid,
  .metric-grid {
    grid-template-columns: 1fr;
  }
  .workflow-item {
    min-height: 100px;
  }
  .comparison-images,
  .example-grid {
    grid-template-columns: 1fr;
  }
  .image-stage {
    min-height: 280px;
  }
  .pixel-readout {
    margin-left: 0;
  }
  .correlation-grid {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }
  .gallery-grid {
    grid-template-columns: 1fr;
  }
  .docs-toc {
    grid-template-columns: repeat(2, 1fr);
  }
  .busy-steps {
    grid-template-columns: repeat(2, 1fr);
  }
}`],
})
export class PageHomeComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public Object = Object;
    public Math = Math;

    public activeView: string = 'home';
    public busy: boolean = false;
    public busyTitle: string = '';
    public busyStage: string = '';
    public errorMessage: string = '';
    public runtime: any = null;
    public jobs: any[] = [];
    public jobSummary: any = { total: 0, running: 0, completed: 0, failed: 0 };
    public pollTimer: any = null;

    public navigation: any[] = [
        { id: 'home', label: '홈', short: 'HM' },
        { id: 'simulation', label: '단일 시뮬레이션', short: 'SIM' },
        { id: 'result', label: '시뮬레이션 결과', short: 'RES' },
        { id: 'dataset', label: '합성데이터셋', short: 'DATA' },
        { id: 'analysis', label: '품질 분석', short: 'QA' },
        { id: 'reconstruction', label: '수치 재구성', short: 'REC' },
        { id: 'history', label: '작업 이력', short: 'LOG' },
        { id: 'docs', label: '문서 및 사용법', short: 'DOC' },
    ];

    public simForm: any = {
        cell_model: 'sphere',
        diameter_um: 8,
        major_axis_um: 10,
        minor_axis_um: 6,
        cell_refractive_index: 1.38,
        x_um: 0,
        y_um: 0,
        z_um: 0,
        wavelength_nm: 532,
        medium_refractive_index: 1.333,
        sensor_distance_um: 120,
        pixel_size_um: 1.12,
        width: 128,
        height: 128,
        brightness_variation: 0.08,
        noise_sigma: 0.015,
        seed: 42
    };

    public fields: any[] = [
        { group: '세포', key: 'diameter_um', label: '세포 지름', unit: 'μm', min: 0.2, max: 30, step: 0.1, help: '구형 세포의 전체 지름', model: 'sphere' },
        { group: '세포', key: 'major_axis_um', label: '장축', unit: 'μm', min: 0.2, max: 40, step: 0.1, help: '타원체의 가장 긴 전체 축', model: 'spheroid' },
        { group: '세포', key: 'minor_axis_um', label: '단축', unit: 'μm', min: 0.2, max: 30, step: 0.1, help: '타원체의 짧은 전체 축', model: 'spheroid' },
        { group: '세포', key: 'cell_refractive_index', label: '세포 굴절률', unit: 'n', min: 1, max: 2.5, step: 0.001, help: '세포 내부의 실수 굴절률' },
        { group: '위치', key: 'x_um', label: 'X 오프셋', unit: 'μm', min: -2000, max: 2000, step: 0.1, help: '센서 중심 기준 수평 위치' },
        { group: '위치', key: 'y_um', label: 'Y 오프셋', unit: 'μm', min: -2000, max: 2000, step: 0.1, help: '센서 중심 기준 수직 위치' },
        { group: '위치', key: 'z_um', label: 'Z 오프셋', unit: 'μm', min: -1000, max: 1000, step: 0.1, help: '기준 센서 거리에서의 추가 깊이' },
        { group: '광학', key: 'wavelength_nm', label: '광원 파장', unit: 'nm', min: 350, max: 1100, step: 1, help: '진공 중 조명 파장' },
        { group: '광학', key: 'medium_refractive_index', label: '매질 굴절률', unit: 'n', min: 1, max: 2, step: 0.001, help: '세포 주변 매질의 굴절률' },
        { group: '광학', key: 'sensor_distance_um', label: '세포-센서 거리', unit: 'μm', min: 5, max: 5000, step: 1, help: '세포 중심과 센서 평면 사이 기준 거리' },
        { group: '센서', key: 'pixel_size_um', label: '픽셀 간격', unit: 'μm', min: 0.05, max: 20, step: 0.01, help: '인접 센서 픽셀 중심 사이 거리' },
        { group: '센서', key: 'width', label: '영상 가로', unit: 'px', min: 32, max: 512, step: 1, help: '출력 영상의 가로 픽셀 수' },
        { group: '센서', key: 'height', label: '영상 세로', unit: 'px', min: 32, max: 512, step: 1, help: '출력 영상의 세로 픽셀 수' },
        { group: '영상', key: 'brightness_variation', label: '밝기 변화', unit: 'ratio', min: 0, max: 0.5, step: 0.005, help: '센서 면의 선형 조명 불균일 진폭' },
        { group: '영상', key: 'noise_sigma', label: '가우시안 잡음', unit: 'σ', min: 0, max: 0.5, step: 0.001, help: '정규분포 잡음의 표준편차' },
        { group: '영상', key: 'seed', label: '난수 시드', unit: 'integer', min: 0, max: 2147483647, step: 1, help: '동일 결과 재현을 위한 정수 시드' },
    ];
    public formErrors: any = {};
    public formWarnings: string[] = [];

    public singleResult: any = null;
    public colorMap: string = 'gray';
    public imageZoom: number = 1;
    public pixelInfo: any = null;
    public lastPixelRender: number = 0;

    public datasetForm: any = {
        diameters: '6,8,10',
        refractive_indices: '1.36,1.38,1.40',
        wavelengths: '450,532',
        distances: '80,120,180',
        noises: '0.005,0.02',
        repeats: 2,
        seed: 1000,
        train: 70,
        validation: 15,
        test: 15,
        width: 64,
        height: 64
    };
    public activeDatasetJob: any = null;
    public datasetResult: any = null;
    public analysisVariable: string = 'diameter_um';
    public analysisRows: any[] = [];
    public analysisFilter: any = { min_contrast: -1, min_snr: -999, sort_by: 'sample_index', order: 'asc', page: 1 };
    public analysisTotal: number = 0;

    public reconstructionForm: any = {
        depth_min_um: 50,
        depth_max_um: 180,
        depth_step_um: 10
    };
    public reconstructionResult: any = null;
    public reconstructionIndex: number = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.loadRuntime();
        await this.loadJobs();
        let latest = this.jobs.find((job) => job.type === 'single' && job.status === 'completed');
        if (latest) {
            await this.loadResult(latest.job_id, false);
        } else if (this.runtime?.ok) {
            await this.runSimulation(true);
        }
        this.pollTimer = window.setInterval(async () => {
            await this.pollActiveJobs();
        }, 1800);
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.pollTimer) window.clearInterval(this.pollTimer);
    }

    public async call(functionName: string, payload: any = {}) {
        let response = await wiz.call(functionName, { data: JSON.stringify(payload) });
        if (response.code < 200 || response.code >= 300) {
            throw new Error(response.data?.message || response.message || '요청 처리에 실패했습니다.');
        }
        return response.data;
    }

    public async notifyError(error: any) {
        this.errorMessage = error?.message || String(error);
        await this.service.modal.show({
            title: '요청을 완료하지 못했습니다',
            message: this.errorMessage,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
        await this.service.render();
    }

    public async loadRuntime() {
        try {
            this.runtime = await this.call('runtime_status');
        } catch (error) {
            this.runtime = { ok: false, error: error?.message || String(error) };
        }
    }

    public async setView(view: string) {
        this.activeView = view;
        if (view === 'history') await this.loadJobs();
        if (view === 'analysis' && this.datasetResult) await this.loadAnalysisRows();
        await this.service.render();
    }

    public fieldVisible(field: any) {
        return !field.model || field.model === this.simForm.cell_model;
    }

    public validateSimulation() {
        let errors: any = {};
        let warnings: string[] = [];
        for (let field of this.fields) {
            if (!this.fieldVisible(field)) continue;
            let value = Number(this.simForm[field.key]);
            if (!Number.isFinite(value)) {
                errors[field.key] = '숫자를 입력하세요.';
            } else if (value < field.min || value > field.max) {
                errors[field.key] = `${field.min}~${field.max} ${field.unit}`;
            }
        }
        if (this.simForm.cell_model === 'spheroid' && Number(this.simForm.major_axis_um) < Number(this.simForm.minor_axis_um)) {
            errors.major_axis_um = '장축은 단축 이상이어야 합니다.';
        }
        let radius = this.simForm.cell_model === 'sphere'
            ? Number(this.simForm.diameter_um) / 2
            : Math.max(Number(this.simForm.major_axis_um), Number(this.simForm.minor_axis_um)) / 2;
        if (Number(this.simForm.sensor_distance_um) + Number(this.simForm.z_um) <= radius) {
            errors.sensor_distance_um = '센서 거리가 세포 반경보다 커야 합니다.';
        }
        let xLimit = Number(this.simForm.width) * Number(this.simForm.pixel_size_um) * 0.425;
        let yLimit = Number(this.simForm.height) * Number(this.simForm.pixel_size_um) * 0.425;
        if (Math.abs(Number(this.simForm.x_um)) > xLimit) errors.x_um = `센서 유효 범위 ±${xLimit.toFixed(1)} μm`;
        if (Math.abs(Number(this.simForm.y_um)) > yLimit) errors.y_um = `센서 유효 범위 ±${yLimit.toFixed(1)} μm`;
        if (Number(this.simForm.cell_refractive_index) <= Number(this.simForm.medium_refractive_index)) {
            warnings.push('세포 굴절률이 매질보다 낮아 회절 링 대비가 작을 수 있습니다.');
        }
        if (this.simForm.cell_model === 'spheroid') {
            warnings.push('타원체는 HoloPy Mie 등체적 구 근사로 계산되며 결과 메타데이터에 표시됩니다.');
        }
        if (Number(this.simForm.width) * Number(this.simForm.height) > 262144) {
            errors.width = '전체 픽셀 수는 262,144 이하로 설정하세요.';
        }
        this.formErrors = errors;
        this.formWarnings = warnings;
        return Object.keys(errors).length === 0;
    }

    public async runSimulation(silent: boolean = false) {
        if (!this.validateSimulation()) {
            if (!silent) await this.notifyError(new Error('입력값의 범위와 물리 조건을 확인하세요.'));
            return;
        }
        this.busy = true;
        this.busyTitle = 'HoloPy 전방 시뮬레이션';
        this.busyStage = '입력 검증 → 산란체 구성 → calc_holo → 품질 분석 → 파일 저장';
        await this.service.render();
        try {
            this.singleResult = await this.call('simulate', { params: this.simForm });
            this.simForm = { ...this.singleResult.params };
            this.colorMap = 'gray';
            this.imageZoom = 1;
            await this.loadJobs();
            if (!silent) this.activeView = 'result';
        } catch (error) {
            await this.notifyError(error);
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public async rerunSame() {
        if (!this.singleResult?.job_id) return;
        this.busy = true;
        this.busyTitle = '동일 조건 재현성 계산';
        this.busyStage = '저장된 입력값과 난수 시드로 HoloPy를 다시 실행합니다.';
        await this.service.render();
        try {
            this.singleResult = await this.call('rerun', { job_id: this.singleResult.job_id });
            await this.loadJobs();
            this.activeView = 'result';
        } catch (error) {
            await this.notifyError(error);
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public imageUrl(kind: string) {
        return this.singleResult?.images?.[kind]?.[this.colorMap] || '';
    }

    public zoom(delta: number) {
        this.imageZoom = Math.min(4, Math.max(0.5, this.imageZoom + delta));
        this.service.render();
    }

    public async inspectPixel(event: MouseEvent, kind: string) {
        let now = Date.now();
        if (now - this.lastPixelRender < 60) return;
        this.lastPixelRender = now;
        let target = event.currentTarget as HTMLImageElement;
        let preview = this.singleResult?.preview?.[kind === 'shadow' ? 'shadow' : 'hologram'];
        if (!target || !preview?.values) return;
        let rect = target.getBoundingClientRect();
        let x = Math.max(0, Math.min(preview.width - 1, Math.floor((event.clientX - rect.left) / rect.width * preview.width)));
        let y = Math.max(0, Math.min(preview.height - 1, Math.floor((event.clientY - rect.top) / rect.height * preview.height)));
        this.pixelInfo = { kind, x, y, value: preview.values[y][x] };
        await this.service.render();
    }

    public parseLevels(raw: string) {
        return String(raw || '')
            .split(',')
            .map((value) => Number(value.trim()))
            .filter((value) => Number.isFinite(value));
    }

    public get datasetCount() {
        let lengths = [
            this.parseLevels(this.datasetForm.diameters).length,
            this.parseLevels(this.datasetForm.refractive_indices).length,
            this.parseLevels(this.datasetForm.wavelengths).length,
            this.parseLevels(this.datasetForm.distances).length,
            this.parseLevels(this.datasetForm.noises).length
        ];
        if (lengths.some((value) => value === 0)) return 0;
        return lengths.reduce((acc, value) => acc * value, 1) * Math.max(1, Number(this.datasetForm.repeats) || 1);
    }

    public get splitTotal() {
        return Number(this.datasetForm.train) + Number(this.datasetForm.validation) + Number(this.datasetForm.test);
    }

    public async applyPreset() {
        this.datasetForm = {
            ...this.datasetForm,
            diameters: '6,8,10',
            refractive_indices: '1.36,1.38,1.40',
            wavelengths: '450,532',
            distances: '80,120,180',
            noises: '0.005,0.02',
            repeats: 2,
            seed: 1000,
            width: 64,
            height: 64
        };
        await this.service.render();
    }

    public async startDataset() {
        if (this.datasetCount < 1 || this.datasetCount > 2000) {
            await this.notifyError(new Error('생성 수는 1~2,000개여야 합니다.'));
            return;
        }
        if (Math.abs(this.splitTotal - 100) > 0.001) {
            await this.notifyError(new Error('학습·검증·시험 분할 비율 합은 100%여야 합니다.'));
            return;
        }
        let base = {
            ...this.simForm,
            width: Number(this.datasetForm.width),
            height: Number(this.datasetForm.height),
            seed: Number(this.datasetForm.seed)
        };
        let payload = {
            base_params: base,
            sweep: {
                diameter_um: this.parseLevels(this.datasetForm.diameters),
                cell_refractive_index: this.parseLevels(this.datasetForm.refractive_indices),
                wavelength_nm: this.parseLevels(this.datasetForm.wavelengths),
                sensor_distance_um: this.parseLevels(this.datasetForm.distances),
                noise_sigma: this.parseLevels(this.datasetForm.noises)
            },
            repeats: Number(this.datasetForm.repeats),
            seed: Number(this.datasetForm.seed),
            split: {
                train: Number(this.datasetForm.train),
                validation: Number(this.datasetForm.validation),
                test: Number(this.datasetForm.test)
            }
        };
        this.busy = true;
        this.busyTitle = '비동기 데이터셋 작업 등록';
        this.busyStage = '조합과 분할을 검증하고 HoloPy 워커를 시작합니다.';
        await this.service.render();
        try {
            let started = await this.call('start_dataset', payload);
            this.activeDatasetJob = {
                job_id: started.job_id,
                type: 'dataset',
                status: 'running',
                stage: '계산 프로세스 시작',
                progress: 0,
                total: this.datasetCount,
                success: 0,
                failed: 0
            };
            await this.loadJobs();
        } catch (error) {
            await this.notifyError(error);
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public async pollActiveJobs() {
        let active = this.activeDatasetJob;
        if (!active?.job_id || !['queued', 'running', 'paused'].includes(active.status)) return;
        try {
            this.activeDatasetJob = await this.call('get_job', { job_id: active.job_id });
            if (String(this.activeDatasetJob.status).startsWith('completed')) {
                this.datasetResult = await this.call('get_result', { job_id: active.job_id });
                await this.loadAnalysisRows();
                await this.loadJobs();
            }
        } catch (error) {
            this.errorMessage = error?.message || String(error);
        }
        await this.service.render();
    }

    public async controlDataset(action: string) {
        if (!this.activeDatasetJob?.job_id) return;
        try {
            this.activeDatasetJob = await this.call('job_action', {
                job_id: this.activeDatasetJob.job_id,
                action
            });
        } catch (error) {
            await this.notifyError(error);
        }
        await this.service.render();
    }

    public async loadJobs() {
        try {
            let data = await this.call('list_jobs');
            this.jobs = data.jobs || [];
            this.jobSummary = data.summary || this.jobSummary;
            if (!this.activeDatasetJob) {
                this.activeDatasetJob = this.jobs.find((job) =>
                    job.type === 'dataset' && ['queued', 'running', 'paused'].includes(job.status)
                ) || null;
            }
        } catch (error) {
            this.errorMessage = error?.message || String(error);
        }
        await this.service.render();
    }

    public async loadResult(jobId: string, navigate: boolean = true) {
        this.busy = true;
        this.busyTitle = '저장 결과 불러오기';
        this.busyStage = '작업 메타데이터와 산출물을 읽고 있습니다.';
        await this.service.render();
        try {
            let result = await this.call('get_result', { job_id: jobId });
            if (result.type === 'single') {
                this.singleResult = result;
                this.simForm = { ...result.params };
                if (navigate) this.activeView = 'result';
            } else if (result.type === 'dataset') {
                this.datasetResult = result;
                this.activeDatasetJob = this.jobs.find((job) => job.job_id === jobId) || result;
                await this.loadAnalysisRows();
                if (navigate) this.activeView = 'analysis';
            } else if (result.type === 'reconstruction') {
                this.reconstructionResult = result;
                this.reconstructionIndex = 0;
                if (navigate) this.activeView = 'reconstruction';
            }
        } catch (error) {
            await this.notifyError(error);
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public async verifyDataset() {
        if (!this.datasetResult?.job_id) return;
        try {
            this.datasetResult.verification = await this.call('verify_dataset', { job_id: this.datasetResult.job_id });
        } catch (error) {
            await this.notifyError(error);
        }
        await this.service.render();
    }

    public async loadAnalysisRows() {
        if (!this.datasetResult?.job_id) return;
        try {
            let result = await this.call('dataset_rows', {
                job_id: this.datasetResult.job_id,
                ...this.analysisFilter
            });
            this.analysisRows = result.rows || [];
            this.analysisTotal = result.total || 0;
        } catch (error) {
            this.errorMessage = error?.message || String(error);
        }
        await this.service.render();
    }

    public async changeAnalysisPage(delta: number) {
        let maxPage = Math.max(1, Math.ceil(this.analysisTotal / 20));
        this.analysisFilter.page = Math.max(1, Math.min(maxPage, Number(this.analysisFilter.page) + delta));
        await this.loadAnalysisRows();
    }

    public get comparisonRows() {
        return this.datasetResult?.analysis?.comparisons?.[this.analysisVariable] || [];
    }

    public get correlationItems() {
        return this.datasetResult?.analysis?.correlations || [];
    }

    public correlationColor(value: number) {
        let magnitude = Math.min(1, Math.abs(Number(value)));
        return Number(value) >= 0
            ? `rgba(13, 148, 136, ${0.12 + magnitude * 0.72})`
            : `rgba(30, 64, 175, ${0.12 + magnitude * 0.72})`;
    }

    public get radialPoints() {
        let values = this.singleResult?.metrics?.radial_brightness || [];
        if (!values.length) return '';
        let min = Math.min(...values);
        let max = Math.max(...values);
        return values.map((value, index) => {
            let x = values.length === 1 ? 0 : index / (values.length - 1) * 560;
            let y = 170 - (value - min) / Math.max(max - min, 1e-9) * 150;
            return `${x.toFixed(1)},${y.toFixed(1)}`;
        }).join(' ');
    }

    public get distributionBars() {
        let data = this.datasetResult?.analysis?.distributions?.contrast;
        if (!data?.counts?.length) return [];
        let max = Math.max(...data.counts, 1);
        return data.counts.map((count, index) => ({
            count,
            height: Math.max(4, count / max * 120),
            label: data.edges[index]?.toFixed(3)
        }));
    }

    public async runReconstruction() {
        if (!this.singleResult?.job_id) {
            await this.notifyError(new Error('먼저 단일 시뮬레이션 결과를 선택하세요.'));
            return;
        }
        let count = Math.floor(
            (Number(this.reconstructionForm.depth_max_um) - Number(this.reconstructionForm.depth_min_um))
            / Number(this.reconstructionForm.depth_step_um)
        ) + 1;
        if (!Number.isFinite(count) || count < 2 || count > 60) {
            await this.notifyError(new Error('재구성 슬라이스 수는 2~60개여야 합니다.'));
            return;
        }
        this.busy = true;
        this.busyTitle = 'HoloPy 수치 역전파';
        this.busyStage = '전달함수 계산 → 깊이 스택 생성 → 초점 점수 평가 → 파일 저장';
        await this.service.render();
        try {
            this.reconstructionResult = await this.call('reconstruct', {
                job_id: this.singleResult.job_id,
                ...this.reconstructionForm
            });
            this.reconstructionIndex = 0;
            await this.loadJobs();
        } catch (error) {
            await this.notifyError(error);
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }

    public get currentReconstruction() {
        return this.reconstructionResult?.slices?.[Number(this.reconstructionIndex)] || null;
    }

    public async deleteJob(job: any) {
        let confirmed = window.confirm(`${job.job_id} 작업과 결과 파일을 삭제할까요? 이 작업은 되돌릴 수 없습니다.`);
        if (!confirmed) return;
        try {
            await this.call('delete_job', { job_id: job.job_id });
            if (this.singleResult?.job_id === job.job_id) this.singleResult = null;
            if (this.datasetResult?.job_id === job.job_id) this.datasetResult = null;
            await this.loadJobs();
        } catch (error) {
            await this.notifyError(error);
        }
    }

    public statusLabel(status: string) {
        let labels: any = {
            queued: '대기',
            running: '실행 중',
            paused: '일시정지',
            completed: '완료',
            completed_with_errors: '오류 포함 완료',
            failed: '실패',
            cancelled: '취소'
        };
        return labels[status] || status;
    }

    public statusClass(status: string) {
        if (status === 'completed') return 'status-success';
        if (status === 'running' || status === 'queued') return 'status-running';
        if (status === 'paused' || status === 'completed_with_errors') return 'status-warning';
        return 'status-error';
    }

    public downloadUrl(jobId: string, type: string) {
        let base = '/wiz/api/page.home/download';
        let params = new URLSearchParams({ type });
        if (jobId) params.set('job_id', jobId);
        return `${base}?${params.toString()}`;
    }

    public download(jobId: string, type: string) {
        window.open(this.downloadUrl(jobId, type), '_blank');
    }
}

export default PageHomeComponent;